import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AlertTriangle, X, CreditCard } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const SubscriptionWarning = () => {
  const { token, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [subStatus, setSubStatus] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [bannerDismissed, setBannerDismissed] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !token) return;
    const check = async () => {
      try {
        const res = await fetch(`${API_URL}/api/subscription/status`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          setSubStatus(data);
          if (data.warning) {
            const lastShown = sessionStorage.getItem("sub_popup_shown");
            if (!lastShown) {
              setShowPopup(true);
              sessionStorage.setItem("sub_popup_shown", "true");
            }
          }
        }
      } catch { /* silent */ }
    };
    check();
  }, [isAuthenticated, token]);

  if (!subStatus?.warning || !isAuthenticated) return null;

  return (
    <>
      {/* 상단 경고 배너 */}
      {!bannerDismissed && (
        <div className="bg-red-600 text-white" data-testid="subscription-warning-banner">
          <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-between">
            <div className="flex items-center gap-2 text-sm">
              <AlertTriangle className="w-4 h-4 flex-shrink-0" />
              <span>{subStatus.message}</span>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => navigate("/membership")}
                className="px-3 py-1 bg-white text-red-600 rounded-lg text-xs font-bold hover:bg-red-50 transition-colors"
                data-testid="subscription-renew-btn"
              >
                지금 갱신하기
              </button>
              <button
                onClick={() => setBannerDismissed(true)}
                className="p-1 hover:bg-white/20 rounded transition-colors"
              >
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 로그인 시 팝업 (세션당 1회) */}
      {showPopup && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4" data-testid="subscription-warning-popup">
          <div className="bg-white rounded-2xl max-w-sm w-full p-6 shadow-2xl text-center">
            <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CreditCard className="w-7 h-7 text-red-500" />
            </div>
            <h3 className="text-lg font-bold text-stone-800 mb-2">
              {subStatus.status === "expired" ? "멤버십이 만료되었습니다" : "멤버십 갱신 필요"}
            </h3>
            <p className="text-sm text-stone-500 mb-5 leading-relaxed">
              {subStatus.message}
            </p>
            <button
              onClick={() => { setShowPopup(false); navigate("/membership"); }}
              className="w-full py-3 bg-red-500 hover:bg-red-600 text-white rounded-xl font-bold text-sm transition-colors mb-2"
            >
              멤버십 갱신하기
            </button>
            <button
              onClick={() => setShowPopup(false)}
              className="w-full py-2 text-stone-400 hover:text-stone-600 text-sm transition-colors"
            >
              나중에
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default SubscriptionWarning;
